// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a9mRx","colBig":"styles_colBig__3wmTQ","colSmall":"styles_colSmall__31cz5"};